import { flow, Instance, types } from 'mobx-state-tree'
import { addPackageToMId } from '../../network/addPackageToMId'
import { deletePackageToMId } from '../../network/deletePackageToMId'
import { getAllPackageToMIds } from '../../network/getAllPackageToMIds'
import { getPackageToMIdById } from '../../network/getPackageToMIdById'
import { getVerifiedMId } from '../../network/getVerifiedMId'
import { pToMIdProcessApprovals } from '../../network/pToMIdProcessApprovals'
import { updatePackageToMId } from '../../network/updatePackageToMId'
import { getErrorMessage, MessageTypes } from '../../utils'
import { FORM_MESSAGE, MDR_FEE_PACKAGE_FILETYPE } from '../../utils/constants'
import { RootStore } from '../store'

const FeePackageMId = types.model('FeePackageMId', {
  type: types.optional(types.literal('feePackage2MId'), 'feePackage2MId'),
  id: types.maybeNull(types.number),
  mid: types.optional(types.string, ''),
  packageName: types.optional(types.string, ''),
})

const FeePackageToMId = types
  .model('FeePackageToMId', {
    feePackageMId: types.optional(FeePackageMId, {}),
    feePackageMIds: types.array(FeePackageMId),
  })
  .actions((self) => ({
    getAll: flow(function* getAll(data: any, paginationInfo: any) {
      try {
        const response = yield getAllPackageToMIds(data, paginationInfo, MDR_FEE_PACKAGE_FILETYPE)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getById: flow(function* getById(id: string) {
      try {
        const response = yield getPackageToMIdById(id, RootStore.session.getTokens)
        const own = self
        own.feePackageMId = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    add: flow(function* add(data: any) {
      try {
        const response = yield addPackageToMId(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    update: flow(function* update(data: any) {
      try {
        const response = yield updatePackageToMId(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    deletePackage: flow(function* deletePackage(data: any) {
      try {
        const response = yield deletePackageToMId(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),

    processApprovals: flow(function* processApprovals(data: any) {
      try {
        const response = yield pToMIdProcessApprovals(data, RootStore.session.getTokens, MDR_FEE_PACKAGE_FILETYPE)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    verifyMId: flow(function* verifyMId(mid: string) {
      try {
        const response = yield getVerifiedMId(mid, RootStore.session.getTokens, MDR_FEE_PACKAGE_FILETYPE)
        // RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getPackageMids() {
      return self.feePackageMIds.map((item: any) => {
        return {
          ...item,
          id: `${item.id}`,
          edit: 'edit',
          delete: 'delete',
        }
      })
    },
    getFilteredPackageMids(listData: any, keys?: any, searchText?: any) {
      const list = listData ?? self?.feePackageMIds ?? []
      const data = list?.map((item: any) => {
        return {
          ...item,
          id: `${item.id}`,
          edit: 'edit',
          delete: 'delete',
        }
      })
      if (keys?.length > 0) {
        if (data.length > 0) {
          if (keys && keys?.length > 0) {
            const retArr: any = []
            data.map((item: any) => {
              let isMatching = true
              keys.map((obj: any) => {
                const val = isNaN(item[obj?.key]) ? item[obj?.key].toLowerCase() : item[obj?.key]?.toString()
                isMatching = isMatching && val.includes(obj?.searchString.toLowerCase())
              })
              isMatching && retArr.push(item)
              return retArr
            })
            return retArr
          } else {
            return listData?.filter((obj: any) =>
              Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchText.toLowerCase())),
            )
          }
        }
      }
      return data
    },
  }))

const feePackageMIDData = FeePackageToMId.create({
  feePackageMId: {},
  feePackageMIds: [],
})

export type PackageToMIdType = Instance<typeof FeePackageToMId>

export { FeePackageMId, feePackageMIDData, FeePackageToMId }
